module.exports = __webpack_public_path__ + "img/about3-main-shape.0b9ce338.png";